<template>
  <div>
    <el-dialog
      :title="title"
      :width="width"
      :visible.sync="isShow"
      style="border-radius: 12px;"
      :before-close="cancel"
    >
      <el-form ref="dialog_form" :model="dialogForm">
        <el-form-item
          v-for="(form_item, from_key) in dialogFormFilter(dialogForm)"
          :key="from_key"
          :prop="from_key + '.value'"
          :label="form_item.label + '：'"
          :label-width="formLabelWidth"
          :rules="form_item.rules ? form_item.rules: null"
        >
          <!-- 选项框 -->
          <el-select
            v-if="form_item.type === 'select'"
            v-model="form_item.value"
            v-bind="getProps(form_item.props, form_item.type)"
            v-on="form_item.on"
          >
            <el-option
              v-for="item in form_item.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-input
            v-if="form_item.type === 'input'"
            v-model="form_item.value"
            v-bind="getProps(form_item.props, form_item.type)"
            v-on="form_item.on"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="format-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" :loading="is_loading" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 宽度
    width: {
      type: String,
      default: '',
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    // 弹框表单数据
    dialogForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 编辑数据
    editData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 创建表单接口
    formDataApi: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      formLabelWidth: '120px',
      el_props: {
        'select': {
          clearable: true,
          size: 'mini',
        },
        'input': {
          clearable: true,
          size: 'mini',
        },
      },
      // 是否加载
      is_loading: false,
    };
  },
  mounted() {
    for (const key in this.dialogForm) {
      if (Object.keys(this.editData).length > 0) {
        this.dialogForm[key].value = this.editData[key];
      } else if (!this.dialogForm[key].hidden){
        this.dialogForm[key].value = null;
      } else {
        this.dialogForm[key].value = 0;
      }
    }
    if (this.dialogForm.type.value && this.dialogForm.type.value !== 2) {
      this.dialogForm.min_millisecond.hidden = true;
      this.dialogForm.max_millisecond.hidden = true;
      this.dialogForm.mime_type.options = [
        {
          label: 'bmp',
          value: 'bmp',
        },
        {
          label: 'jpg',
          value: 'jpg',
        },
        {
          label: 'jpeg',
          value: 'jpeg',
        },
        {
          label: 'png',
          value: 'png',
        },
        {
          label: 'gif',
          value: 'gif',
        },
      ];
    } else if (this.dialogForm.type.value === 2){
      this.dialogForm.min_millisecond.hidden = false;
      this.dialogForm.max_millisecond.hidden = false;
      this.dialogForm.mime_type.options = [
        {
          label: 'mp4',
          value: 'mp4',
        },
        {
          label: 'mov',
          value: 'mov',
        },
        {
          label: 'avi',
          value: 'avi',
        },
      ];
    }
  },
  methods: {
    // 获取props
    getProps: function(props, type) {
      const temp_props = this.el_props[type] ? JSON.parse(JSON.stringify(this.el_props[type])) : {};
      for (const key in props) {
        temp_props[key] = props[key];
      }

      return temp_props;
    },
    // 表单过滤
    dialogFormFilter: function(obj) {
      const temp_obj = {};
      for (const key in obj) {
        if (!obj[key].hidden) {
          temp_obj[key] = obj[key];
        }
      }
      return temp_obj;
    },
    // 取消
    cancel: function() {
      this.$refs.dialog_form.resetFields();
      this.$emit('cancel');
    },
    // 确定
    confirm: function() {
      const format_form_params = {};
      for (const key in this.dialogForm) {
        format_form_params[key] = this.dialogForm[key].value;
      }

      this.is_loading = true;

      this.$refs['dialog_form'].validate((valid, form_rule_list) => {
        if (valid) {
          this.formDataApi(format_form_params, this.editData.id).then((res) => {
            this.is_loading = false;
            this.$emit('confirm', format_form_params);
            this.$refs.dialog_form.resetFields();
          }).catch(() => {
            this.is_loading = false;
          });
        } else {
          this.is_loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  display: block;
}
.format-footer {
  text-align: right;
}
</style>
